export default "__VITE_ASSET__Du2AP6$k__"